// initial state
const state = {
  showPageBtn: false
}

// getters
const getters = {
  showPageBtn: state => state.showPageBtn
}

// mutations
const mutations = {
  setShowPageBtn (state, data) {
    state.showPageBtn = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/scroll.js